var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerified(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2752_2225)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.01683 13.125L3.9085 11.2583L1.8085 10.7917L2.01266 8.63333L0.583496 7L2.01266 5.36667L1.8085 3.20833L3.9085 2.74167L5.01683 0.875L7.00016 1.72083L8.9835 0.875L10.0918 2.74167L12.1918 3.20833L11.9877 5.36667L13.4168 7L11.9877 8.63333L12.1918 10.7917L10.0918 11.2583L8.9835 13.125L7.00016 12.2792L5.01683 13.125ZM6.38766 9.07083L9.6835 5.775L8.86683 4.92917L6.38766 7.40833L5.1335 6.18333L4.31683 7L6.38766 9.07083Z",
    fill: "#20C206"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2752_2225"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerified);
export default __webpack_public_path__ + "static/media/verified.2fc2486a1ce17d373682d0c669ec1727.svg";
export { ForwardRef as ReactComponent };